<script lang="ts" setup>
import MainLayout from '../components/layouts/MainLayout.vue'
import SaleWrap from '../components/sales/SaleWrap.vue'
import { onMounted, ref } from 'vue'
import { SaleInterface } from '../models/SaleModel'
import { getSale } from '../services/saleApi'
import ALoader from '../components/common/ALoader.vue'

const props = defineProps<{ id: string }>()
const saleData = ref<SaleInterface | null>(null)
const loading = ref(true)

onMounted(async () => {
  if (!props.id) {
    loading.value = false
    return
  }
  saleData.value = await getSale(props.id)
  loading.value = false
})
</script>

<template>
  <MainLayout>
    <ALoader v-if="loading" />
    <SaleWrap v-else :sale-data="saleData" />
  </MainLayout>
</template>
